import {
  addDoc,
  collection,
  deleteDoc,
  doc,
  onSnapshot,
  orderBy,
  query,
  serverTimestamp,
  updateDoc,
  where,
} from "firebase/firestore";
import { db } from "./firebase";

const playerListingsRef = collection(db, "playerListings");

export function subscribeToActivePlayerListings(callback) {
  const q = query(playerListingsRef, where("status", "==", "active"), orderBy("createdAt", "desc"));
  return onSnapshot(q, (snap) => {
    callback(snap.docs.map((d) => ({ id: d.id, ...d.data() })));
  });
}

export function subscribeToMyPlayerListings(sellerUserId, callback) {
  const q = query(playerListingsRef, where("sellerUserId", "==", sellerUserId), orderBy("createdAt", "desc"));
  return onSnapshot(q, (snap) => {
    callback(snap.docs.map((d) => ({ id: d.id, ...d.data() })));
  });
}

export function createPlayerListing(sellerUserId, data) {
  return addDoc(playerListingsRef, {
    ...data,
    sellerUserId,
    status: "active",
    createdAt: serverTimestamp(),
    updatedAt: serverTimestamp(),
  });
}

export function updatePlayerListing(listingId, data) {
  return updateDoc(doc(db, "playerListings", listingId), {
    ...data,
    updatedAt: serverTimestamp(),
  });
}

export function markPlayerListingSold(listingId) {
  return updatePlayerListing(listingId, { status: "sold" });
}

export function reactivatePlayerListing(listingId) {
  return updatePlayerListing(listingId, { status: "active" });
}

export function deletePlayerListing(listingId) {
  return deleteDoc(doc(db, "playerListings", listingId));
}
